import React from 'react'

const SlackLink = ({className = '', children, ...rest}) => (
  <a className={className} href='https://www.8thwall.com/slack' target='_blank' {...rest}>{children}</a>
)

export default SlackLink
